
export class CallCenter {
  reference: string;
  name: string;
  email: string;
  phone: string;
  address: string;
  status: string;
  rccm: string;
  ifu: string;
  manager: any;
  country: any;
}





// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/call-center/call-center.model.ts